import OutlinedButton from 'primitives/Buttons/OutlinedButton';
import styled from '@emotion/styled';

const Button = styled(OutlinedButton)({
  marginLeft: 0,
  width: 'fit-content',
});

export default Button;
